var _defs, _g, _line, _line2, _line3, _line4, _line5, _line6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapIcon1 = function SvgMapIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44",
    "data-name": "Group 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.973,
    height: 27.734,
    viewBox: "0 0 32.973 27.734"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 32.973,
    height: 27.734,
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x2: 20.671,
    transform: "translate(6.399 27.344)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 16.459,
    y2: 16.459,
    transform: "translate(16.239 0.321)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x1: 16.459,
    y2: 16.459,
    transform: "translate(0.275 0.275)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x1: 4.597,
    y1: 4.597,
    transform: "translate(12.401 12.749)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x1: 4.597,
    y1: 4.597,
    transform: "translate(4.305 12.749)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x1: 4.597,
    y1: 4.597,
    transform: "translate(20.561 12.749)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y1: 4.597,
    x2: 4.597,
    transform: "translate(16.487 12.749)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    y1: 4.597,
    x2: 4.597,
    transform: "translate(8.35 12.749)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    y1: 4.597,
    x2: 4.597,
    transform: "translate(24.623 12.749)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })));
};

export { SvgMapIcon1 as ReactComponent };
export default "data:image/svg+xml;base64,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";